import { generateRandomNumber } from "../util/";
import { CreateElement } from "./element";
import { CreateText, OptionsText } from "./text";

interface OptionsTableOfContents {
    /** Try to update the TOC when first opened */
    autoUpdate?: boolean;
    /** Outline levels to be displayed. Default as "1-4" */
    showLevels?: string;
    /** Legend. Default as "Click here to update the Table of Contents" */
    legend?: OptionsText;
}

/**
 * Create table of contents
 */
class CreateTableOfContents extends CreateElement {
    /**
     * Element options
     */
    protected options: OptionsTableOfContents;

    /**
     * Constructor
     *
     * @param options - Options table of contents
     */
    constructor(options: OptionsTableOfContents) {
        super();

        // default options
        options.legend ??= {
            text: "Click here to update the Table of Contents",
        };
        options.showLevels ??= "1-4";

        this.options = options;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        let contents = "";
        const tocId = generateRandomNumber(111111111, 999999999, []);
        const legendOption = this.options.legend;
        let legendContent = "";
        if (legendOption != null) {
            const legendElement = new CreateText(legendOption);
            legendContent = legendElement.create();
        }

        contents =
            '<w:sdt><w:sdtPr><w:id w:val="' +
            tocId +
            '"/><w:docPartObj><w:docPartGallery w:val="Table of Contents"/><w:docPartUnique/></w:docPartObj></w:sdtPr><w:sdtContent><w:p><w:pPr></w:pPr><w:fldSimple w:instr="TOC o &quot;' +
            this.options.showLevels +
            '&quot; \\h \\z \\u">' +
            legendContent +
            "</w:fldSimple></w:p></w:sdtContent></w:sdt>";

        return contents;
    }
}

export { CreateTableOfContents, OptionsTableOfContents };
